import {
  filtersPresets,
  getFilterSimpleFiled,
} from "@src/shared/componemts/TableFilter/classes/constants"

const orderOptions = [
  { label: "Newest", value: "desc" },
  { label: "Oldest", value: "asc" },
]

const statusOptions = [
  { label: "Failed", value: "failed" },
  { label: "Pending", value: "pending" },
  { label: "Success", value: "success" },
]

export const transactionsSwapFilters = [
  {
    ...getFilterSimpleFiled("status").select(statusOptions, {
      placeholder: "Select a status",
    }),
    col: 6,
  },
  { ...filtersPresets.order, col: 6 },
]
